<div class="tabs" id="tabs-1" style="background: white;">
        

  
  <div class="form-row" style = "text-align: center;">
    <label style="font-weight: bold; font-size: x-large; text-align: center;">Pharmacology Exam <br>
        (Examen de farmacología)</label>
  
  </div><br><br>
  
  
  <form id="pharmacologyexamform" [formGroup]="regForm"    (ngSubmit)="step16Submitted(regForm)" > 
    

    <div class="container-fluid anyClass">
        

    <div class="row">
            <div class="col-sm-12  col-md-12 col-lg-12 ">


    <div class="form-group">

        <div class="questionContainer radius">
        <div class="question"><b>Question 1: </b>U or u is not an approved Joint Commission abbreviation, you must write Unit<hr /></div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question1"  value="1" required/>True </label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question1"  value="2" required/>False </label>
                    </li>
                </ul>
            </div> 
        </div>

        <div class="questionContainer">
        <div class="question"><b>Question 2: </b>h.s. is an abbreviation for at bedtime.<hr /></div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question2"  value="1" required/>True </label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question2"  value="2" required/>False </label>
                    </li>
                </ul>
            </div> 
        </div>

        <div class="questionContainer">
        <div class="question"><b>Question 3: </b>p.r.n is an abbreviation for whenever necessary.<hr /></div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question3"  value="1" required/>True </label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question3"  value="2" required/>False </label>
                    </li>
                </ul>
            </div> 
        </div>

        <div class="questionContainer">
        <div class="question"><b>Question 4: </b>QD is not an approved Joint Commission abbreviation, you must write Daily.<hr /></div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question4"  value="1" required/>True </label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question4"  value="2" required/>False </label>
                    </li>
                </ul>
            </div> 
        </div>

        <div class="questionContainer">
        <div class="question"><b>Question 5: </b>Q.O.D is not an approved Joint Commission abbreviation, you must write Every Other Day.<hr /></div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question5"  value="1" required/>True </label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question5"  value="2" required/>False </label>
                    </li>
                </ul>
            </div> 
        </div>

        <div class="questionContainer">
            <div class="question">
                <b>Question 6: </b>M.D. order&#58; Amoxicillin 500 mg q 4h
                                &lt;br&gt;Available&#58; 250 mg per tablet
                                &lt;br&gt;How many tablets would you administer?<hr /></div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question6"  value="1" required/>1</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question6"  value="2" required/>2</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question6"  value="3" required/>3</label>
                    </li>
                </ul>
            </div>   
        </div>

        <div class="questionContainer">
            <div class="question">
                <b>Question 7: </b>M.D. order&#58; Augmentin 500 mg q 8h
                                  &lt;br&gt;Available&#58; 250 mg&#47;5 cc
                                  &lt;br&gt;How much would you administer?<hr /></div>
            <div class="answers">
                <ul>
                    <li>
                             <label><input type="radio" formControlName="Question7"  value="1" required/>5 CC</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question7"  value="2" required/>10 CC</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question7"  value="3" required/>1 tablet</label>
                    </li>
                </ul>
            </div>   
        </div>

        <div class="questionContainer">
            <div class="question">
                <b>Question 8: </b>M.D. order&#58; BuSpar 15 mg
                                &lt;br&gt;Available&#58; BuSpar 5 mg tablets
                                &lt;br&gt;How many tablets would you administer?<hr /></div>
            <div class="answers">
                <ul>
                    <li>
                             <label><input type="radio" formControlName="Question8"  value="1" required/>1 tablet</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question8"  value="2" required/>3 tablets</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question8"  value="3" required/>5 tablets</label>
                    </li>
                </ul>
            </div>   
        </div>

        <div class="questionContainer  ">
            <div class="question">
                <b>Question 9: </b>The best site for an IM injection for an unconscious adult who is receiving 1.5 cc of Antibiotic is:<hr /><div>
            <div class="answers">
                <ul>
                    <li>
                             <label><input type="radio" formControlName="Question9"  value="1" required/>scapula</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question9"  value="2" required/>vastis lateralis</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question9"  value="3" required/>deltoid</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question9"  value="4" required/>ventrogluteal</label>
                    </li>
                </ul>
            </div>
        </div>

        <div class="questionContainer">
        <div class="question"><b>Question 10: </b>The abdomen is the site of choice for insulin administration because of its consistent rate of absorption.<hr /></div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question10"  value="1" required/>True </label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question10"  value="2" required/>False </label>
                    </li>
                </ul>
            </div> 
        </div>

        <div class="questionContainer">
        <div class="question"><b>Question 11: </b>Insulin dosage is designated in units.<hr /></div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question11"  value="1" required/>True </label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question11"  value="2" required/>False </label>
                    </li>
                </ul>
            </div> 
        </div>

        <div class="questionContainer">
        <div class="question"><b>Question 12: </b>It is not necessary to rotate injection sites when administering insulin because you are using a very small needle.<hr /></div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question12"  value="1" required/>True </label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question12"  value="2" required/>False </label>
                    </li>
                </ul>
            </div> 
        </div>

        <div class="questionContainer">
        <div class="question"><b>Question 13: </b>Syringe size should be chosen based on weight and age of the patient.<hr /></div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question13"  value="1" required/>True </label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question13"  value="2" required/>False </label>
                    </li>
                </ul>
            </div> 
        </div>

        <div class="questionContainer">
            <div class="question">
                <b>Question 14: </b>You visit Mr. Smith on a routine supervisory visit. He tells you that he still takes Digoxin 0.25 mg daily. You take his vital signs and they are: 110&#58;70, 48, 16, 98.6. 
                                   &lt;br&gt;Based on these vital signs you would advise him to do the following?<hr /></div>
            <div class="answers">
                <ul>
                    <li>
                             <label><input type="radio" formControlName="Question14"  value="1" required/>Continue his present regiment, his blood pressure is excellent.</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question14"  value="2" required/>Add extra salt to his diet, his blood pressure is too low.</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question14"  value="3" required/>Contact his physician. His pulse rate is low. A low heart rate should be reported to the physician because he is taking Digoxin.</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question14"  value="4" required/>Contact his physician. He has a fever and might have an infection.</label>
                    </li>
                </ul>
            </div>   
        </div>

        <div class="questionContainer  ">
            <div class="question">
                <b>Question 15: </b>Optimal effects from opiates such as Morphine Sulfate are attained when given<hr /></div>
            <div class="answers">
                <ul>
                    <li>
                             <label><input type="radio" formControlName="Question15"  value="1" required/>Before the patient experiences intense pain</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question15"  value="2" required/>After the patient experiences intense pain</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question15"  value="3" required/>During intense pain</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question15"  value="4" required/>When the patient asks for it.</label>
                    </li>
                </ul>
            </div>
        </div>

        <div class="questionContainer  ">
            <div class="question">
                <b>Question 16: </b>Your patient is on heparin sodium. He states that &#34;the doctor orders blood tests all the time, so he will know what dose of heparin to give me.&#34; Which of the following blood tests is used to adjust the dose of heparin?<hr /></div>
            <div class="answers">
                <ul>
                    <li>
                             <label><input type="radio" formControlName="Question16"  value="1" required/>Sedimentation rate</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question16"  value="2" required/>Prothrombin time(PT) and partial thromboplastin time (PTT)</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question16"  value="3" required/>Clotting time</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question16"  value="4" required/>LDH level</label>
                    </li>
                </ul>
            </div>
        </div>

        <div class="questionContainer  ">
            <div class="question">
                <b>Question 17: </b>Mr. Jones arrives to the emergency room, unresponsive. His home health aide is holding an empty vial of MS Contin &#40;Slow release Morphine Sulfate&#41;. The emergency room physician suspects accidental overdose of the narcotic. The medication that he will likely order will be:<hr /></div>
            <div class="answers">
                <ul>
                    <li>
                             <label><input type="radio" formControlName="Question17"  value="1" required/>Demerol</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question17"  value="2" required/>Narcan</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question17"  value="3" required/>Fentanyl</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question17"  value="4" required/>Potassium Chloride</label>
                    </li>
                </ul>
            </div>
        </div> 

        <div class="questionContainer  ">
            <div class="question">
                <b>Question 18: </b>Mrs. Smith is taking Penicillin V Potassium for an infection in her foot. When you do a home visit you note that she has a bright red rash on her upper torso and face. You would advise her to call her physician because<hr /></div>
            <div class="answers">
                <ul>
                    <li>
                             <label><input type="radio" formControlName="Question18"  value="1" required/>a.	The infection might have spread from her foot to her upper body and face</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question18"  value="2" required/>b.	There is no reason to call her doctor</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question18"  value="3" required/>c.	She may be experiencing an allergic reaction or hypersensitivity to Penicillin</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question18"  value="4" required/>d.	She may have sat out in the sun for too long of a time period yesterday</label>
                    </li>
                </ul>
            </div>
        </div>

        <div class="questionContainer  ">
            <div class="question">
                <b>Question 19: </b>The &#34;Five Rights&#34; of medication administration are<hr /></div>
            <div class="answers">
                <ul>
                    <li>
                             <label><input type="radio" formControlName="Question19"  value="1" required/>Right patient, right drug, right dose, right route, right time</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question19"  value="2" required/>Right patient, right day, right dose, right use, right time</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question19"  value="3" required/>Right patient, right route, right emergency measures, right time, right location</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question19"  value="4" required/>There is no such thing as the five rights of medication administration</label>
                    </li>
                </ul>
            </div>
        </div>

        <div class="questionContainer  ">
            <div class="question">
                <b>Question 20: </b>	Mrs. Jones tells you that she saved all of her husband John&#39;s medications after he passed away last year. She states &#34;I just might be needing them some day soon.&#34; Your response should be<hr /></div>
            <div class="answers">
                <ul>
                    <li>
                             <label><input type="radio" formControlName="Question20"  value="1" required/>&#34;What a smart idea. In this way you will be prepared if you every get sick.&#34;</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question20"  value="2" required/>&#34;What a smart idea. You can save a lot of money in this way.&#34;</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question20"  value="3" required/>&#34;I would advise that you discard the medication. Using someone else&#39;s medication is not advised and can be dangerous. Dosages often differ.&#34;</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question20"  value="4" required/>&#34;The medication is probably all expired anyhow. Most medication expires in less than a year anyhow.&#34;</label>
                    </li>
                </ul>
            </div>
        </div>

        <div class="questionContainer  ">
            <div class="question">
                <b>Question 21: </b>Pediatric dosages of medication often differ from adult dosages because<hr /></div>
            <div class="answers">
                <ul>
                    <li>
                             <label><input type="radio" formControlName="Question21"  value="1" required/>Adults and children never take the same medications</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question21"  value="2" required/>Medications are often based on body weight</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question21"  value="3" required/>They don't. Pediatric and adult dosages are identical</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question21"  value="4" required/>Children do not take as many different drugs as adults</label>
                    </li>
                </ul>
            </div>
        </div>                

        <div class="questionContainer  ">
            <div class="question">
                <b>Question 22: </b>Heather is taking a ten day course of antibiotics for a diagnosis of bronchitis. You would include the following in your teaching plan<hr /></div>
            <div class="answers">
                <ul>
                    <li>
                             <label><input type="radio" formControlName="Question22"  value="1" required/>It is important to complete the entire course of antibiotics, regardless if symptoms are gone</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question22"  value="2" required/>It is important to stop the antibiotic immediately when the fever and cough disappear</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question22"  value="3" required/>It is important to stop the antibiotic as soon as her sputum becomes clear</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question22"  value="4" required/>It is important to always take the antibiotic at night</label>
                    </li>
                </ul>
            </div>
        </div>

        <div class="questionContainer  ">
            <div class="question">
                <b>Question 23: </b>Which of the following medications is classified as a diuretic?<hr /></div>
            <div class="answers">
                <ul>
                    <li>
                             <label><input type="radio" formControlName="Question23"  value="1" required/>Lipitor</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question23"  value="2" required/>Lasix</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question23"  value="3" required/>Gentamycin</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question23"  value="4" required/>Zantac</label>
                    </li>
                </ul>
            </div>
        </div>

        <div class="questionContainer  ">
            <div class="question">
                <b>Question 24: </b>Which of the following statements concerning oxygen is false?<hr /></div>
            <div class="answers">
                <ul>
                    <li>
                             <label><input type="radio" formControlName="Question24"  value="1" required/>Oxygen can be administered in varying doses.</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question24"  value="2" required/>Oxygen can be used to treat anginal pain.</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question24"  value="3" required/>Oxygen can never be administered to children.</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question24"  value="4" required/>Oxygen is flammable and that fact should be included in patient education.</label>
                    </li>
                </ul>
            </div>
        </div>        

        <div class="questionContainer  ">
            <div class="question">
                <b>Question 25: </b>The term &#34;sublingual&#34; means<hr /></div>
            <div class="answers">
                <ul>
                    <li>
                             <label><input type="radio" formControlName="Question25"  value="1" required/>Under the tongue</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question25"  value="2" required/>Under the arm</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question25"  value="3" required/>In the muscle</label>
                    </li>
                    <li>
                             <label><input type="radio" formControlName="Question25"  value="4" required/>Via the mouth</label>
                    </li>
                </ul>
            </div>
        </div>                        

    </div>



            </div>
    </div>

    <br/>

</div>



<button type="button" (click) = "decreasePage()" class="btn btn-create"  matStepperPrevious><i class="ace-icon fa fa-arrow-left"></i>Prev Page</button>
&nbsp;
<button type="submit"  class="btn btn-primary" >Save and Continue &nbsp;
  <i class="ace-icon fa fa-arrow-right icon-on-right"></i></button>   
  
</div>
</div>

<div class="spinner-border text-success" role="status" style="position: absolute; bottom:10;" *ngIf="isfetching === true"></div>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i className="fa fa-spinner fa-spin  fa-2x" style="color:blue" *ngIf="isfetching === true"> Saving Data...</i>



        </form>


  

</div>
   